/* eslint-disable @typescript-eslint/indent */
// Problem with theming indention
import { css } from '@linaria/core';
import { baseUnits, theming } from 'styles/utils';
export const videoControlsWrapper = "odules__Canvas__components__VideoControls__VideoControls_styles_ts-videoControlsWrapper-v7mvd4k";
export const buttons = "odules__Canvas__components__VideoControls__VideoControls_styles_ts-buttons-b1e843h0";
export const buttonGroup = "odules__Canvas__components__VideoControls__VideoControls_styles_ts-buttonGroup-bzhmupn";
export const timing = "odules__Canvas__components__VideoControls__VideoControls_styles_ts-timing-tdij2yq";
export const timelineWrapper = "odules__Canvas__components__VideoControls__VideoControls_styles_ts-timelineWrapper-t1r204uy";

require("./VideoControls.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./VideoControls.styles.ts");